var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoltFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 2.25a.75.75 0 0 0-.738.616l-1 5.5A.75.75 0 0 0 4 9.25h2.085l-.82 4.103a.75.75 0 0 0 1.285.657l6.5-7a.75.75 0 0 0-.55-1.26H9.994l.727-2.544A.75.75 0 0 0 10 2.25H5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoltFilled);
export default ForwardRef;